<template>
  <div>
    <div class="date-container" :class="{ 'build-date': !isInstant }">
       <div  class="modal-loader" :class="{ 'close-loader' : !modaling}">
                <div class="loader"></div>
            </div>
      <div class="quote-date" :class="{ 'instant-input': isInstant }">
        <Datepicker
          :highlighted="highlighted"
          :disabled-dates="disabledFrom"
          placeholder="Arrival-Date"
          v-model="fromDate"
          @selected="addLimitTo"
        />
      </div>
      <div class="quote-date" :class="{ 'instant-input': isInstant }">
        <Datepicker
          :highlighted="highlighted"
          :disabled-dates="{to: fromDate || new Date() }"
          placeholder="Departure-Date"
          v-model="toDate"
          @selected="highlightTo"
          ref="openTo"
        />
      </div>
    <div class="quote-buttons instant-btn" >
                    <button class="orange-btn build-package"
                   @click="fetchGolfItems">Search</button>
            </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
  name: "SearchBox",
  components: {
    Datepicker,
  },
  data() {
    return {
      fromDate: "",
      toDate: "",
      disabledFrom: {
        to: new Date(),
      },
      highlighted: {},
    };
  },
  computed: {
    isInstant() {
      return this.$store.state.instantQuote.isInstant;
    },
    modaling() {
      return this.$store.state.instantQuote.showModal;
    }
  },

  methods: {
    addLimitTo(val) {
      if(!this.toDate) {
        this.toDate = this.addDay(val);
      }
      this.highlightFrom(val);
      
    },
    highlightFrom(){
      if(typeof this.highlighted.from === "undefined") {
        this.highlighted = {
          to: this.highlighted.to,
          daysOfMonth: this.highlighted.daysOfMonth,
          from: null,
        };
      }
    },
    highlightTo(val) {
      if(typeof this.highlighted.from === "undefined") {
        this.highlighted = {
          to: null,
          daysOfMonth: this.highlighted.daysOfMonth,
          from: this.highlighted.from,
        };
        console.log(this.fromDate)
      }
      this.highlighted.to = val;
    },
    addDay(val) {
      let d = new Date(val);
      let aDay = 1440 * 60 * 1000;
      let d2 = new Date(Math.trunc((d.getTime() + aDay) / aDay) * aDay);
      return d2.toString();
    },
    async fetchGolfItems(){
      console.log("entered fetchGolfItems")
      let obj = {
        data: {
          StartDate: moment(this.fromDate).format("YYYY-MM-DD"),
          EndDate: moment(this.toDate).format("YYYY-MM-DD")
        }
      }
      await this.$store.dispatch('instantQuote/fetchGolfItems', obj).then(() => {
        this.render = false;
            this.$nextTick(() => {
              console.log('next tick');
                this.render = true;
            });
      }       
      );
      
    }
  }
};
</script>

<style lang="scss">
.close-loader {
  display: none;
}
.listOfGolfers {
  color: black !important;
  font-size: 18px !important;
}
.modal-loader {
  position: fixed; /* Stay in place */
  z-index: 1200; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.7); /* Black w/ opacity */
  .loader {
    top: 45%;
    border: 16px solid #f3f3f3;
    border-top: 16px solid #5e4896;
    border-radius: 50%;
    left: 45%;
    width: 120px;
    position: relative;
    height: 120px;
    animation: spin 1.3s linear infinite;
    @media screen and (max-width: 1024px) {
      top: 40%;
      left: 40%;
    }
    @media screen and (max-width: 768px) {
      top: 39%;
      left: 39%;
    }
    @media screen and (max-width: 540px) {
      top: 35%;
      left: 35%;
    }
    @media screen and (max-width: 375px) {
      top: 36%;
      left: 31%;
    }
    @media screen and (max-width: 360px) {
      top: 37%;
      left: 28%;
    }
    @media screen and (max-width: 414px) {
      top: 35%;
      left: 33%;
    }
    @media screen and (max-width: 411px) {
      top: 39%;
      left: 34%;
    }
    @media screen and (max-width: 320px) {
      top: 31%;
      left: 27%;
    }
  }
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
.vdp-datepicker {
  div :first-of-type {
    background: transparent !important;
  }
}
.vdp-datepicker__calendar {
  width: 300px !important;
}
.date-container {
  display: flex !important;
  flex-wrap: wrap !important;
  justify-content: space-between !important;
  padding: 30px 40px !important;
  margin-bottom: 17px !important;
  &.build-date {
    border-bottom: 2px solid #5e4896 !important;
  }
  input {
    &::placeholder {
      color: #5e4896;
    }
    &:focus,
    &:active {
      outline: none;
    }
  }
  @media screen and (max-width: 850px) {
    .quote-date:nth-child(2) {
      .vdp-datepicker__calendar {
        right: 0;
      }
    }
  }
  .quote-date,
  .quote-golfers {
    background-color: #ffffff;
    width: calc(27% - 40px);
    &.instant-input {
      width: calc(35% - 40px);
      @media screen and (max-width: 768px) {
        width: calc(35% - 20px);
      }
      @media screen and (max-width: 600px) {
        width: 100%;
      }
    }
    @media screen and (max-width: 1440px) {
      width: calc(27% - 30px);
    }
    @media screen and (max-width: 1200px) {
      width: calc(27% - 20px);
    }
    @media screen and (max-width: 800px) {
      width: calc(50% - 10px);
      margin-top: 10px;
    }
    @media screen and (max-width: 500px) {
      width: 100%;
    }
    position: relative;
    .vdp-datepicker {
      input {
        border-radius: 10px;
        border: 1px solid #cccccc;
        padding: 20px 21px;
        font-weight: 500;
        width: 100%;
        height: 65px;
      }
      *:not(.disabled) {
        color: #5e4896;
        font-size: 18px;
        @media screen and (max-width: 1250px) {
          font-size: 14px;
        }
      }
      .cell {
        &.day {
          border: 1px solid #fff;
          &.disabled {
            background: #cdc3e4;
            color: #fff;
          }
          &:not(.blank):not(.disabled):not(.highlighted):not(.selected) {
            background: #5e4896;
            color: #fff;
          }
          &.highlighted {
            background: #ffba5a;
            color: #fff;
          }
          &.selected {
            background: #ff9600;
            color: #fff;
          }
        }
      }
    }
    .fa-icon {
      // position: absolute;
      // top: 15px;
      // right: 20px;
      // bottom: 0;
      font-size: 32px;
      color: #5e4896;
      @media screen and (max-width: 1250px) {
        font-size: 24px;
        top: 18px;
      }
    }
  }
  .quote-golfers {
    border-radius: 10px;
    border: 1px solid #cccccc;
    height: 65px;
    display: flex;
    align-items: center;
    * {
      cursor: pointer;
    }
    input {
      font-size: 18px;
      @media screen and (max-width: 1250px) {
        font-size: 14px;
        height: 22px;
      }
      border: none;
      border-radius: 10px;
      padding: 20px 21px;
      font-weight: 500;
      width: 100%;
    }
    ul {
      list-style: none;
      border: 1px solid #cccccc;
      margin: 0;
      padding: 0 20px;
      background: #fff;
      position: absolute;
      width: 100%;
      top: 100%;
      z-index: 1;
      &.hidden {
        display: none;
      }
      li:not(:last-child) {
        border-bottom: 1px solid #cccccc;
        padding: 10px 10px;
      }
      li:last-child {
        padding: 10px 10px;
      }
    }
  }
  .quote-buttons {
    height: 65px;
    width: calc(27% - 50px);
    display: flex;
    @media screen and (max-width: 800px) {
      width: calc(50% - 10px);
      margin-top: 10px;
    }
    @media screen and (max-width: 500px) {
      width: 100%;
    }
    &.instant-btn {
      display: block;
      width: 30%;
      text-align: center;
      @media screen and (max-width: 1100px) {
        width: 36%;
      }
      .orange-btn {
        width: 300px !important;
        height: auto;
        @media screen and (max-width: 1350px) {
          height: 65px;
        }
        @media screen and (max-width: 750px) {
          width: 256px !important;
        }
        @media screen and (max-width: 400px) {
          width: 100% !important;
        }
      }
    }&.instant-btn:active {
      background-color: #3e8e41;
  box-shadow: 0 5px #666;
  transform: translateY(4px);
    }
    .orange-btn {
      font-size: 18px;
      cursor: pointer;
      background-color: #ff9600;
      color: #fff;
      text-transform: uppercase;
      border: none;
      border-radius: 0.521vw;
      padding: 20px 21px;
      font-weight: 500;
      width: auto;
      text-align: center;
      @media screen and (max-width: 1250px) {
        font-size: 12px;
        padding: 0;
      }
      &.golf {
        width: calc(50% - 5px);
        border: 1px solid #ff9600;
        color: #ff9600;
        background: #fff;
        margin-right: 5px;
      }
      &.continue {
        width: calc(50% - 5px);
      }
      &.build-package {
        width: 100%;
      }
    }
  }
  .instant-dates {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .instant-date {
      border: 1px solid #cccccc;
      color: #5e4896;
      margin-top: 20px;
      border-radius: 0.521vw;
      width: 19% !important;
      margin-right: 10px;
      @media screen and (max-width: 1200px) {
        width: calc(20% - 12px) !important;
      }
      @media screen and (max-width: 1024px) {
        width: calc(33% - 12px) !important;
      }
      @media screen and (max-width: 768px) {
        width: calc(50% - 12px) !important;
      }
      @media screen and (max-width: 500px) {
        width: 100% !important;
        margin: 10px 0 0 !important ;
      }
      .instant-header {
        border-bottom: 1px solid #cccccc;
        padding: 15px 7px;
        font-size: 16px;
        font-weight: 500;
        text-align: center;
        @media screen and (max-width: 500px) {
          font-size: 16px;
        }
      }
      .instant-body {
        padding: 22px 21px;
        .instant-item:not(:last-child) {
          margin-bottom: 24px;
        }
      }
    }
  }
}
</style>
